/** Campos anidados de order en queries de servicios (programación / detail-file). */
export const SERVICE_ORDER_FIELDS = `
  orderId
  orderNumber
  displayCode
  orderStatus
  reservationNumber
  reservationStatus
  orderObservation
  scheduledPaymentDate
  freezeDeadlineAt
  paidAt
  pdfStatus
  pdfGeneratedAt
  lastPdfError
  commissionAmount
  commissionPercent
  autoAdjusted
  lastRecalculatedAt
`;
